<template>
  <div class="flex-grow pt-10 px-4 sm:px-10">
    <div class="flex flex-col">
      <p
        class="text-elections-primary-600 bg-elections-tertiary p-1 w-[max-content] font-semibold text-sm mb-2"
      >
        Candidate nomination
      </p>
      <h3 class="text-elections-primary-600">
        {{ selectedElection?.election_name }}
      </h3>
    </div>

    <FormNomination />
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'
import FormNomination from './FormNomination.vue'

export default defineComponent({
  name: 'ElectionNomination',
  components: { FormNomination },

  setup() {
    const store = useStore()

    const selectedElection = computed(
      () => store.getters['elections/getCurrentElection'],
    )

    return {
      selectedElection,
    }
  },
})
</script>
